module.exports = __webpack_public_path__ + "media/images/common/heart-check-8c07d29b5ee7e4319d8e9331eed7a9d8.svg";